var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-highlight-subtext"},_vm._l((_vm.textList),function(text,index){return _c('span',{key:`key-${index}`,style:(_vm.getStyle(index)),domProps:{"textContent":_vm._s(text)}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }